// Scanner look: dim image, glowing ridges, grid, sweeping scan line.
// Pair with the "Edge scan" vertex effect (ridges come from vElevation).
vec3 effect(vec2 uv)
{
    vec3 tint = vec3(0.2, 1.0, 0.8);
    vec3 base = vec3(luma(sampleCam(uv))) * tint * 0.25;

    vec3 ridge = tint * vElevation * 1.5;

    vec2 grid = abs(fract(uv * 40.0) - 0.5);
    float gridLine = 1.0 - smoothstep(0.0, 0.04, min(grid.x, grid.y));

    float sweepY = fract(uTime * 0.25);
    float sweep = exp(-abs(uv.y - sweepY) * 60.0);

    return base + ridge + tint * gridLine * 0.08 + vec3(0.6, 1.0, 1.0) * sweep * (0.3 + vElevation) * uAmount * 2.0;
}
